import { render, staticRenderFns } from "./VOrderSyncMsg.vue?vue&type=template&id=755e6571&scoped=true"
import script from "./VOrderSyncMsg.vue?vue&type=script&lang=ts"
export * from "./VOrderSyncMsg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e6571",
  null
  
)

export default component.exports